export const menuList = [
  {
    title: "Home",
    href: "/",
    key: "home",
  },
  {
    title: "Use Cases",
    href: "/use-cases/",
    key: "use-cases",
  },
  {
    title: "Agent Framework",
    href: "https://eko.fellou.ai/",
    key: "agent-framework",
  },
  {
    title: "Pricing",
    href: "/pricing/",
    key: "pricing",
  },
  // {
  //   title: "Github",
  //   key: "github",
  //   href: "github",
  // },

  {
    key: "blog",
    href: "https://fellou.ai/blog",
    title: "Blog",
  },
];
